// extracted by mini-css-extract-plugin
export var cardContainer = "_oo-0";
export var cardHeader = "_oo-2";
export var collapsedState = "_oo-3";
export var dragHandle = "_oo-5";
export var dragHandleIcon = "_oo-6";
export var dragging = "_oo-1";
export var titleArea = "_oo-4";